module.exports = __webpack_public_path__ + "img/thumbnail_DallSheep_j_normal.caa86ec2.png";